import React from "react";
import { Controller } from "react-hook-form";

const DropdownField = ({ name, label, options, control, rules, onChange }) => (
  <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px" }}>
    <label>
      {label}
      {rules?.required && <span style={{ color: "red" }}> *</span>}
    </label>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <select
            {...field}
            onChange={(e) => {
              field.onChange(e); // Update the form state
              if (onChange) onChange(e); // Call external onChange handler, if provided
            }}
            style={error ? { borderColor: "red" } : {}}
          >
            <option value="">Select</option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {error && <span style={{ color: "red", fontSize: "12px" }}>{error.message}</span>}
        </>
      )}
    />
  </div>
);

export default DropdownField;
